/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTScrollto } from './scrollto';
export type { KTScrolltoConfigInterface, KTScrolltoInterface } from './types';
